
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
    Users,
    Briefcase,
    LogOut,
    LayoutDashboard,
    MessageSquare
} from 'lucide-react';
import { motion } from 'framer-motion';

export default function AdminSidebar() {
    const navigate = useNavigate();

    const handleLogout = () => {
        if (window.confirm('Are you sure you want to logout?')) {
            localStorage.removeItem('admin_token');
            navigate('/admin/auth/login');
        }
    };

    const navItems = [
        { path: '/admin/crm/dashboard', name: 'CRM Dashboard', icon: LayoutDashboard },
        { path: '/admin/users', name: 'Users', icon: Users },
        { path: '/admin/crm/leads', name: 'Leads', icon: Users },
        { path: '/admin/crm/referral-sources', name: 'Referral Sources', icon: Briefcase },
        { path: '/admin/crm/tasks', name: 'Tasks', icon: MessageSquare },
        { path: '/admin/crm/reports', name: 'CRM Reports', icon: LayoutDashboard },
        { path: '/admin/referrals', name: 'Site Referrals', icon: Users },
        { path: '/admin/services', name: 'Services', icon: Briefcase },
        { path: '/admin/contacts', name: 'Contacts', icon: MessageSquare },
    ];

    return (
        <aside className="w-64 bg-white border-r border-gray-200 min-h-screen flex flex-col fixed left-0 top-0 z-30">
            <div className="p-6 border-b border-gray-100 flex items-center justify-center">
                <h2 className="text-2xl font-bold bg-gradient-to-r from-teal-600 to-teal-800 bg-clip-text text-transparent">
                    Admin Panel
                </h2>
            </div>

            <nav className="flex-1 p-4 space-y-2">
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) => `
                            flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200
                            ${isActive
                                ? 'bg-teal-50 text-teal-700 font-semibold shadow-sm'
                                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                            }
                        `}
                    >
                        <item.icon className="w-5 h-5" />
                        <span>{item.name}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="p-4 border-t border-gray-100">
                <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-3 px-4 py-3 text-red-600 hover:bg-red-50 rounded-xl transition-colors"
                >
                    <LogOut className="w-5 h-5" />
                    <span>Logout</span>
                </button>
            </div>
        </aside>
    );
}
